import React from "react";
import "../../styleDotmatrix.css";
import { useSelector } from "react-redux";
import Receipts from "Components/Print/dot-invoice-receipt";
import customerService from "Service/Customer/customer.service";
import { Box, Grid, Table, TableCell, TableRow } from "@mui/material";
import { width } from "@mui/system";
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";
import { currency } from "Components/MUI_components/currencyFormatterTag";
import { TitumDetails } from "titum-layouts/shared-components/TitumDetails";



const Print = React.forwardRef((props, ref) => {

  const { invoiceCode, date } = useSelector((state) => state.lastInsertInvoice);
  // const printedDate = date ? new Date(date) : new Date();
  var currentDate = new Date();
  var today = currentDate.toLocaleString(); 
  
  const {submittedData,pageStatus} = props
  // const { stockHistories, customer, salesQuotation, invoiceExt } = data;
  const { stockHistories, customer,invoiceExt } = submittedData;
  // invoiceExt.code is Only available when invoice recall
  //Stock History Level
  const handleLineTotal = (qty, price, discountPer, discountAmount) => {
    let totalAmount = qty * price;
    discountAmount = discountAmount * qty;
    let lineTotalAmount = totalAmount - totalAmount * (discountPer / 100) - discountAmount;
    return lineTotalAmount;
  };

  //Invoice Level Calculations

  // const subTotalAmount = stockHistories
  //   .map(({ quantity, discountPercentage, discountAmount, retailPrice }) =>
  //     handleLineTotal(

  //       quantity,
  //       retailPrice,
  //       discountPercentage,
  //       discountAmount
  //     )
  //   )
  //   .reduce((sum, i) => sum + i, 0);

  // const billDiscount =
  //   subTotalAmount * (data.discountPercentage / 100) +
  //   parseFloat(data.discountAmount ? data.discountAmount : 0);

  // const totalAmount = stockHistories
  //   .map(({ quantity, discountPercentage, discountAmount, retailPrice }) =>
  //     handleLineTotal(

  //       quantity,
  //       retailPrice,
  //       discountPercentage,
  //       discountAmount
  //     )
  //   )
  //   .reduce((sum, i) => sum + i, 0) - billDiscount;

  // const totalLineDiscount = (stockHistories
  //   .map(({ quantity, retailPrice }) =>

  //     quantity *
  //     retailPrice
  //   )
  //   .reduce((sum, i) => sum + i, 0)) - subTotalAmount;

  //const discountTotal = billDiscount + totalLineDiscount;

  var nextServiceDate = new Date();
  if (invoiceExt.vehicleMaster) {
    nextServiceDate.setDate(
      new Date().getDate() + parseInt(invoiceExt.vehicleMaster.servicePeriod)
    );
  }
  
  var formattedDate = nextServiceDate.toISOString().split('T')[0];
  

  return (

    <Box>
        <div className="printArea" ref={ref} style={{padding:"2px"}}>
      <>
        <Receipts
          date={date}
          title={`INVOICE ${props.code && "RE-Printed"} - ${submittedData.code ? submittedData.code : props.code}`}
        >


          <table className="print-table-pos">
            <Box sx={{marginLeft:10,marginRight:10}} p={2}>
            <div align="center"><strong>{`INVOICE ${pageStatus.recalled ? "Re-Printed" : ""} - ${submittedData.code ?? props.code}`}</strong></div>
            <div style={{ borderTop: "1px solid #24242450" }}></div>
            </Box>
            
            <Grid container>
              <Grid item xs={5}>
                <Box sx={{marginLeft:10}}>
                  <table>
                  <tr><td>{COLUMNS_NAME.DATE} :  {pageStatus.recalled ? submittedData.date :  today }</td></tr>
                    <tr>
                      <td>
                        {customer?.code}
                      </td>
                    </tr>
                    <tr>
                      <td>

                        To: {customer ? customer.firstName + " " + (customer.secondName ? customer.secondName : "") : "Cash"}
                      </td>
                    </tr>


                    <tr>
                      <td>

                        {customer && customer.customerAddresses.map((row) => (
                          row.address ?  row.address: ""
                        ))}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {customer && customer.customerAddresses.map((row) => (
                          row.city ?  row.city : ""
                        ))}
                      </td>
                    </tr>
                    <tr>
                      <td>

                        {customer && customer.customerAddresses.map((row) => (
                          row.phone2 + row.phone1 ? row.phone2 + row.phone1 : ""                        ))}
                      </td>
                    </tr>
                  </table>
                </Box>

              </Grid>

              {invoiceExt.vehicleMaster && (
                    <><Grid item xs={7}>
                    <Box sx={{ marginLeft: 10 }}>
                      <table>
                      
                        <tr><td>{COLUMNS_NAME.VEHICLE_NO} : {invoiceExt.vehicleMaster?.vehicleNumber}</td></tr>
                        <tr><td>{COLUMNS_NAME.DESCRIPTION} : {invoiceExt.vehicleMaster?.description}</td></tr>
                        <tr><td>{COLUMNS_NAME.NEXT_SERVICE_DATE} : {invoiceExt?.nextServiceDate ? invoiceExt?.nextServiceDate: formattedDate  }</td></tr>
                        <tr><td>{COLUMNS_NAME.METER_READING} : {` ${invoiceExt.odoReading ? invoiceExt.odoReading : 0 } km`  }  </td></tr>
                        {/* <tr><td>{COLUMNS_NAME.NEXT_SERVICE_KM} : {invoiceExt.nextServiceKm ? invoiceExt.nextServiceKm +" Km":  (invoiceExt.odoReading ? invoiceExt.odoReading + invoiceExt.vehicleMaster.serviceKm + " km" : "" )  }</td></tr> */}
                        <tr><td>{COLUMNS_NAME.NEXT_SERVICE_KM} : {parseFloat(invoiceExt.odoReading) + parseFloat(invoiceExt.vehicleMaster.serviceKm) + " km" }</td></tr>

                      </table>
                    </Box>

                  </Grid>
                  
                  {/* <Grid item xs={4}>
                      <Box sx={{ marginRight: 10 }}>
                        <table>
                          <tr><td></td></tr>

                          <tr><td></td></tr>
                          <tr><td></td></tr>
                          <tr><td></td></tr>
                          <tr><td></td></tr>
                          <tr><td></td></tr>
                        </table>
                      </Box>
                    </Grid> */}
                    
                    </>
              )}
          
            
            
              
            </Grid>
            </table>

           
          <table >
            
          
            <Box sx={{marginLeft:10,marginRight:10, marginTop:2 }}>
          
              <table
              // aria-label="spanning table"
              className="print-table-pos"
              style={{ marginRight: 100, fontSize:36 }}
            >
       
              <thead className="thead"> 
                <tr
                  style={{
                    borderTop: "1px solid #24242450",
                    borderBottom: "1px solid #24242450",    
                  }}>

                  <th align="left" width="30">#</th>
                  <th align="left" width="350" >
                    <strong>{COLUMNS_NAME.DESCRIPTION}</strong>
                  </th>
                  <th align="center" width="100">
                    <strong>{COLUMNS_NAME.QUANTITY}</strong>
                  </th>
                  <th align="center" width="100">
                    <strong>{COLUMNS_NAME.UNIT_PRICE}</strong>
                  </th>
                  <th align="center" width="100">
                    <strong>{COLUMNS_NAME.DISCOUNT_PERCENTAGE}</strong>
                  </th>
                  <th align="right" width="100">
                    <strong>{COLUMNS_NAME.DISCOUNT_AMOUNT}</strong>
                  </th>
                  <th align="right" width="100">
                    <strong>{COLUMNS_NAME.AMOUNT} </strong></th>
                </tr>
              </thead>

              
             
              <tbody style={{fontSize:6}}>
                {stockHistories
                  .filter(i => i.quantity > 0)
                  .map((row, index) => (
                    < React.Fragment key={index} >
                      <tr>
                        <td>
                          <td>{index + 1}. </td>
                        </td>
                        <td style={{ wordBreak: "break-word" }}>
                        {row && (row.name ? row.name : (row.itemMaster && row.itemMaster.name) ? row.itemMaster.name + " - " + (row.itemMaster.description || '') : '')}
                        </td>

                        <td align="center">{row.quantity}</td>
                        <td align="center">{currency(row.retailPrice)}</td>
                        <td align="center">{currency(row.discountPercentage)}</td>
                        <td align="right">{currency(row.discountAmount)}</td>
                        <td marginLeft="50px" align="right">{currency(
                          handleLineTotal(
                            row.quantity,
                            row.retailPrice,
                            row.discountPercentage,
                            row.discountAmount
                          )
                        )}</td>


                      </tr>
                    </React.Fragment>

                  ))}

              </tbody>
            </table>
            
           
            <div style={{ borderTop: "1px solid #24242450" }}></div>
            </Box>
           
          
            <Grid container style={{padding:2 }}>
              
              <Grid item xs={4}>
                <Box sx={{marginLeft:15}}>
                <table>
                  <today>
                    <tr><td>{COLUMNS_NAME.PAYMENT_RECIEVED} :</td></tr>
                    <tr><td>{COLUMNS_NAME.BALANCE_GIVEN} :</td></tr>
                    <tr><td>{COLUMNS_NAME.PAYEMENT_TYPE} :</td></tr>
                    <tr><td>{COLUMNS_NAME.OUTSTANDING} :</td></tr>
                  </today>
                </table>
                </Box>
              
              </Grid>
              <Grid item xs={2}>
                <Box >
                <table>
                  <today>
                    <tr><td align="right"> {currency(submittedData.receivedAmount ? submittedData.receivedAmount : 0)}</td> </tr>
                    <tr><td align="right"> {submittedData.receivedAmount >= submittedData.totalAmount ? `${currency(submittedData.receivedAmount - submittedData.totalAmount)}` : "0.00"}</td></tr>
                    <tr><td align="right">{submittedData.receivedAmount ? "Cash" : "Credit"}</td></tr>
                    <tr><td align="right">  {pageStatus.recalled ? currency(customer?.creditAmount) : 
                             submittedData.totalAmount > submittedData.receivedAmount ?
                             (parseFloat(submittedData.totalAmount)  - parseFloat(submittedData.receivedAmount) ) + parseInt(customer?.creditAmount) + ".00" : currency(customer?.creditAmount)
                             }</td></tr>
                  </today>
                </table>
                </Box>
               
              </Grid>
              <Grid item xs={3}>
                <Box>
                <table>
                  <today>
                    <tr><td> {COLUMNS_NAME.SUB_TOTAL} :</td></tr>
                    <tr><td>   {COLUMNS_NAME.BILL_DISCOUNT_PERCENTAGE}({submittedData.discountPercentage}%) : </td></tr>
                    <tr><td> {COLUMNS_NAME.BILL_DISCOUNT_AMOUNT} : </td></tr>
                    <tr><td style={{ fontSize: 15 }}><strong>{COLUMNS_NAME.LAST_TOTAL} :</strong> </td></tr>
                  </today>
                </table>
                </Box>
               
              </Grid>
              <Grid item xs={2}>
                <Box >
                <table>
                  <today>
                    <tr><td align="right"> {currency(submittedData.subTotalAmount)}</td></tr>
                    <tr><td align="right"> {currency(submittedData.discountPercentage / 100 * submittedData.subTotalAmount)} </td></tr>
                    <tr  ><td align="right"> {currency(submittedData.discountAmount)}</td></tr>
                    <tr><td align="right"><strong>{currency(submittedData.totalAmount)}</strong> </td></tr>
                  </today>
                </table>
                </Box>
             
              </Grid>
            </Grid>
            <Box sx={{marginLeft:10,marginRight:15}}>
           
            </Box>
          </table>



          {/*  Printed with Biz X */}
          {/* <div padding="2px" style={{borderTop: "1px solid #24242450"}}></div> */}

          <Box sx={{marginLeft:10,marginRight:10}}>
          <div className="row" style={{ marginTop: 50 }}>
            <hr/>
            <div className="col-6">
              <div
                style={{
                  borderTop: "1px dashed #000000",
                  textAlign: "center",
                }}
              >
                Customer
              </div>
            </div>


            <div className="col-6">
              <div
                style={{
                  borderTop: "1px dashed #000000",
                  textAlign: "center",
                }}
              >
                Authorized signature
              </div>
            </div>
          </div>
          </Box>
         
        </Receipts>
      </>
    </div >

    </Box>

    

  );
});

export default React.memo(Print);

